<template>
  <a-row :gutter="10">
    <a-col :span="selectedRowKeys.length >= 1?12:24">
      <a-card :bordered="false">
        <!-- 查询区域 -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline"
                  @keyup.enter.native="searchQuery">
            <div class="div-query-banner">
              <a-form-item label="项目名">
                <j-input placeholder="请输入项目名"
                         v-model="queryParam.name"></j-input>
              </a-form-item>
              <a-form-item label="完工状态">
                <a-select :allowClear="true"
                          v-model="queryParam.compleState">
                  <a-select-option :value="0">
                    已完工
                  </a-select-option>
                  <a-select-option :value="1">
                    进行中
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="战略层级">
                <j-dict-select-tag dictCode="project_daily_strategic_level"
                                   placeholder="请输入战略层级"
                                   v-model="queryParam.level"></j-dict-select-tag>
              </a-form-item>
              <a-button class="query-banner-btn margin-left-auto"
                        type="primary"
                        @click="searchQuery"
                        icon="search">查询</a-button>
              <a-button class="query-banner-btn"
                        type="primary"
                        @click="searchReset"
                        icon="reload"
                        style="margin-left: 8px">重置</a-button>
            </div>
            <!-- <a-row :gutter="24">
              <a-col :xl="6"
                     :lg="7"
                     :md="8"
                     :sm="24">
                <a-form-item label="项目经理">
                  <a-input placeholder="请输入项目经理"
                           v-model="queryParam.manager"></a-input>
                </a-form-item>
              </a-col>
              <a-col :xl="10"
                     :lg="11"
                     :md="12"
                     :sm="24">
                <a-form-item label="创建时间">
                  <j-date placeholder="请选择开始日期"
                          class="query-group-cust"
                          v-model="queryParam.createTime_begin"></j-date>
                  <span class="query-group-split-cust"></span>
                  <j-date placeholder="请选择结束日期"
                          class="query-group-cust"
                          v-model="queryParam.createTime_end"></j-date>
                </a-form-item>
              </a-col>
              <template v-if="toggleSearchStatus">
                <a-col :xl="10"
                       :lg="11"
                       :md="12"
                       :sm="24">
                  <a-form-item label="预计结束时间">
                    <j-date placeholder="请选择开始日期"
                            class="query-group-cust"
                            v-model="queryParam.endTime_begin"></j-date>
                    <span class="query-group-split-cust"></span>
                    <j-date placeholder="请选择结束日期"
                            class="query-group-cust"
                            v-model="queryParam.endTime_end"></j-date>
                  </a-form-item>
                </a-col>
                <a-col :xl="10"
                       :lg="11"
                       :md="12"
                       :sm="24">
                  <a-form-item label="预计开始时间">
                    <j-date placeholder="请选择开始日期"
                            class="query-group-cust"
                            v-model="queryParam.startTime_begin"></j-date>
                    <span class="query-group-split-cust"></span>
                    <j-date placeholder="请选择结束日期"
                            class="query-group-cust"
                            v-model="queryParam.startTime_end"></j-date>
                  </a-form-item>
                </a-col>
                <a-col :xl="10"
                       :lg="11"
                       :md="12"
                       :sm="24">
                  <a-form-item label="未结项分数">
                    <a-input placeholder="请输入最小值"
                             class="query-group-cust"
                             v-model="queryParam.outstandScore_begin"></a-input>
                    <span class="query-group-split-cust"></span>
                    <a-input placeholder="请输入最大值"
                             class="query-group-cust"
                             v-model="queryParam.outstandScore_end"></a-input>
                  </a-form-item>
                </a-col>
                <a-col :xl="6"
                       :lg="7"
                       :md="8"
                       :sm="24">
                  <a-form-item label="是否完工">
                    <a-input placeholder="请输入是否完工"
                             v-model="queryParam.compleState"></a-input>
                  </a-form-item>
                </a-col>
                <a-col :xl="6"
                       :lg="7"
                       :md="8"
                       :sm="24">
                  <a-form-item label="项目名">
                    <a-input placeholder="请输入项目名"
                             v-model="queryParam.name"></a-input>
                  </a-form-item>
                </a-col>
                <a-col :xl="10"
                       :lg="11"
                       :md="12"
                       :sm="24">
                  <a-form-item label="总分">
                    <a-input placeholder="请输入最小值"
                             class="query-group-cust"
                             v-model="queryParam.totalScore_begin"></a-input>
                    <span class="query-group-split-cust"></span>
                    <a-input placeholder="请输入最大值"
                             class="query-group-cust"
                             v-model="queryParam.totalScore_end"></a-input>
                  </a-form-item>
                </a-col>
                <a-col :xl="6"
                       :lg="7"
                       :md="8"
                       :sm="24">
                  <a-form-item label="战略层级">
                    <a-input placeholder="请输入战略层级"
                             v-model="queryParam.level"></a-input>
                  </a-form-item>
                </a-col>
                <a-col :xl="10"
                       :lg="11"
                       :md="12"
                       :sm="24">
                  <a-form-item label="战略层级系数">
                    <a-input placeholder="请输入最小值"
                             class="query-group-cust"
                             v-model="queryParam.levelCoefficient_begin"></a-input>
                    <span class="query-group-split-cust"></span>
                    <a-input placeholder="请输入最大值"
                             class="query-group-cust"
                             v-model="queryParam.levelCoefficient_end"></a-input>
                  </a-form-item>
                </a-col>
                <a-col :xl="10"
                       :lg="11"
                       :md="12"
                       :sm="24">
                  <a-form-item label="难度系数">
                    <a-input placeholder="请输入最小值"
                             class="query-group-cust"
                             v-model="queryParam.courseRat_begin"></a-input>
                    <span class="query-group-split-cust"></span>
                    <a-input placeholder="请输入最大值"
                             class="query-group-cust"
                             v-model="queryParam.courseRat_end"></a-input>
                  </a-form-item>
                </a-col>
              </template>
              <a-col :xl="6"
                     :lg="7"
                     :md="8"
                     :sm="24">
                <span style="float: left;overflow: hidden;"
                      class="table-page-search-submitButtons">
                  <a-button type="primary"
                            @click="searchQuery"
                            icon="search">查询</a-button>
                  <a-button type="primary"
                            @click="searchReset"
                            icon="reload"
                            style="margin-left: 8px">重置</a-button>
                  <a @click="handleToggleSearch"
                     style="margin-left: 8px">
                    {{ toggleSearchStatus ? '收起' : '展开' }}
                    <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
                  </a>
                </span>
              </a-col>
            </a-row> -->
          </a-form>
        </div>
        <!-- 查询区域-END -->

        <!-- 操作按钮区域 -->
        <div class="table-operator">
          <a-button @click="handleAdd"
                    type="primary"
                    icon="plus">新增</a-button>
        </div>

        <!-- table区域-begin -->
        <div>
          <div>
            <a-table :key="leftTableKey"
                     ref="table"
                     size="middle"
                     bordered
                     rowKey="id"
                     :columns="columns"
                     :dataSource="dataSource"
                     :pagination="ipagination"
                     :loading="loading"
                     :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange, type:'radio'}"
                     :customRow="customTable1"
                     :scroll="{x:true,y:false}"
                     @change="handleTableChange">
              <div slot="compleState"
                   slot-scope="text">
                <div v-if="text === 0"
                     class="comple-state-green">完工</div>
                <div v-else-if="text === 1"
                     class="comple-state-red">进行中</div>
              </div>
              <div slot="action"
                   slot-scope="text,record">
                <a v-if="record.compleState === 1"
                   @click="handleChangeCompleState(record,0)">设为完工</a>
              </div>
            </a-table>
          </div>
        </div>

        <busDailyProject-modal ref="modalForm"
                               @ok="modalFormOk"></busDailyProject-modal>
      </a-card>
    </a-col>
    <a-col :span="12"
           v-if="selectedRowKeys.length >= 1">
      <a-card>
        <a-menu v-model="currentSubTableMenu"
                mode="horizontal">
          <a-menu-item key="MEMBER">
            项目成员
          </a-menu-item>
          <a-menu-item key="MEMBERS_THE_HISTORICAL_CHANGES">
            成员历史变动
          </a-menu-item>
          <a-menu-item key="MEMBERS_NEXT">
            成员待生效
          </a-menu-item>
          <a-menu-item key="BENEFIT_DEPARTMENT">
            受益部门
          </a-menu-item>
          <!-- <a-menu-item key="EXAMINATION_APPROVAL_RECORDS">
            评价记录
          </a-menu-item> -->
        </a-menu>
        <bus-daily-project-user-list @changeMenus="handleChangeMenus($event)"
                                     v-show="currentSubTableMenu[0]==='MEMBER'"
                                     :projectRecords="selectionRows"   ref="projectUserlistRef"  @refresh="handleRefreshUsers"  ></bus-daily-project-user-list>
        <bus-daily-project-depart-list v-show="currentSubTableMenu[0]==='BENEFIT_DEPARTMENT'"
                                       :projectRecords="selectionRows"></bus-daily-project-depart-list>
        <bus-daily-project-user-history v-show="currentSubTableMenu[0]==='MEMBERS_THE_HISTORICAL_CHANGES'"
                                        :projectRecords="selectionRows"  ref="projectUserHistoryRef"   ></bus-daily-project-user-history>
        <bus-daily-project-user-next-list ref="projectUserNextRef"
                                          v-show="currentSubTableMenu[0]==='MEMBERS_NEXT'"
                                          :projectRecords="selectionRows" @refresh="handleRefreshUsers"  ></bus-daily-project-user-next-list>
        <bus-daily-project-scoring-record-list v-show="currentSubTableMenu[0]==='EXAMINATION_APPROVAL_RECORDS'"
                                               :projectRecords="selectionRows"></bus-daily-project-scoring-record-list>
      </a-card>
    </a-col>
  </a-row>
</template>

<script>

import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import BusDailyProjectModal from './modules/BusDailyProjectModal'
import JDictSelectTag from '@/components/dict/JDictSelectTag.vue'
import JDate from '@/components/jeecg/JDate.vue'
import JInput from '@/components/jeecg/JInput.vue'
import BusDailyProjectUserList from './components/BusDailyProjectUserList.vue'
import BusDailyProjectDepartList from './components/BusDailyProjectDepartList.vue'
import BusDailyProjectUserHistory from './components/BusDailyProjectUserHistory.vue'
import BusDailyProjectScoringRecordList from './components/BusDailyProjectScoringRecordList.vue'
import BusDailyProjectUserNextList from './components/BusDailyProjectUserNextList.vue'
import { getAction } from '@/api/manage'
import { editDailyProject } from '@/api/api'

export default {
  name: "BusDailyProjectList",
  mixins: [JeecgListMixin],
  components: {
    JDictSelectTag,
    JDate,
    BusDailyProjectModal,
    BusDailyProjectUserList,
    BusDailyProjectDepartList,
    BusDailyProjectUserHistory,
    BusDailyProjectScoringRecordList,
    BusDailyProjectUserNextList,
    JInput
  },
  data () {
    return {
      currentSubTableMenu: ["MEMBER"],
      leftTableKey: new Date().valueOf(),
      description: 'bus_daily_project管理页面',
      // 表头
      columns: [
        {
          title: '项目名',
          align: "center",
          dataIndex: 'name',
        },
        {
          title: '完工状态',
          align: "center",
          dataIndex: 'compleState',
          scopedSlots: { customRender: 'compleState' },
        },
        {
          title: '项目经理',
          align: "center",
          dataIndex: 'manager_dictText'
        },
        {
          title: '总分',
          align: "center",
          dataIndex: 'totalScore'
        },
        {
          title: '未结项分数',
          align: "center",
          dataIndex: 'outstandScore'
        },
        {
          title: '预计开始时间',
          align: "center",
          dataIndex: 'startTime',
          customRender: function (text) {
            return !text ? "" : (text.length > 10 ? text.substr(0, 10) : text)
          }
        },
        {
          title: '预计结束时间',
          align: "center",
          dataIndex: 'endTime',
          customRender: function (text) {
            return !text ? "" : (text.length > 10 ? text.substr(0, 10) : text)
          }
        },
        {
          title: '战略层级',
          align: "center",
          dataIndex: 'level_dictText'
        },
        {
          title: '基础分',
          align: "center",
          dataIndex: 'baseScore'
        },
        {
          title: '创建时间',
          align: "center",
          dataIndex: 'createTime',
          customRender: function (text) {
            return !text ? "" : (text.length > 10 ? text.substr(0, 10) : text)
          }
        },
        {
          title: '战略层级系数',
          align: "center",
          dataIndex: 'levelCoefficient'
        },
        {
          title: '难度系数',
          align: "center",
          dataIndex: 'courseRat'
        },
        {
          title: '操作',
          align: "center",
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          fixed: "right"
        },
      ],
      url: {
        list: "/dailyproject/busDailyProject/list",
        delete: "/dailyproject/busDailyProject/delete",
        deleteBatch: "/dailyproject/busDailyProject/deleteBatch",
        exportXlsUrl: "/dailyproject/busDailyProject/exportXls",
        importExcelUrl: "dailyproject/busDailyProject/importExcel",
      },
      customTable1: (record) => {
        return {
          on: { // 事件
            click: (event) => {
              this.selectedRowKeys = ["" + record.id];
              this.selectionRows = [record]
            },
          },
        }
      },
      dictOptions: {},
    }
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
    }
  },
  methods: {
    handleRefreshUsers(){
      this.$refs.projectUserNextRef.initData();
      this.$refs.projectUserlistRef.initData();
      this.$refs.projectUserHistoryRef.initData();
    },
    handleChangeMenus (val) {
      this.currentSubTableMenu = [val];
    },
    loadData (arg) {
      if (!this.url.list) {
        this.$message.error('请设置url.list属性!')
        return
      }
      //加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1
      }
      var params = this.getQueryParams() //查询条件
      this.loading = true
      this.dataSource = []
      getAction(this.url.list, params).then((res) => {
        if (res.success) {
          this.dataSource = res.result.records
          if (this.dataSource.length > 0 && this.selectionRows.length === 0) {
            this.selectedRowKeys = ["" + this.dataSource[0].id];
            this.selectionRows = [this.dataSource[0]]
          }
          this.ipagination.total = res.result.total
          this.pageRefresh++
        } else {
          this.$message.warning(res.message)
        }
        if (res.code === 510) {
          this.$message.warning(res.message)
        }
        this.loading = false
      })
    },
    handleChangeCompleState (record, val) {
      editDailyProject({ id: record.id, compleState: val }).then((res) => {
        if (res.success) {
          this.$message.success("完工成功！")
          this.loadData()
        } else {
          this.$message.error(res.message)
        }
      }).catch((err) => {
        this.$message.error(err.message)
      })
    },
    loadData (arg) {
      if (!this.url.list) {
        this.$message.error('请设置url.list属性!')
        return
      }
      //加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1
      }
      var params = this.getQueryParams() //查询条件
      this.loading = true
      this.dataSource = []
      getAction(this.url.list, params).then((res) => {
        if (res.success) {
          this.dataSource = res.result.records
          if (this.dataSource.length > 0 && this.selectionRows.length === 0) {
            this.selectedRowKeys = ["" + this.dataSource[0].id];
            this.selectionRows = [this.dataSource[0]]
          }
          this.ipagination.total = res.result.total
          this.pageRefresh++
        } else {
          this.$message.warning(res.message)
        }
        if (res.code === 510) {
          this.$message.warning(res.message)
        }
        this.loading = false
      })
    },
  }
}
</script>
<style lang="less" scoped>
@import '~@assets/less/common.less';
/deep/ .ant-table td {
  white-space: nowrap;
}
/deep/ .ant-table th {
  white-space: nowrap;
}
.div-query-banner {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  & > *:nth-child(n) {
    width: 370px;
  }
  & > *:nth-child(n + 2) {
    margin-left: 12px;
  }
  & > .query-banner-btn:nth-child(n) {
    width: 100px;
  }
  .margin-left-auto {
    margin-left: auto;
  }
}
.comple-state-green {
  color: green;
}
.comple-state-red {
  color: red;
}
</style>